import React from 'react';

import TeamSection from '../../components/TeamSection';
import { getAllTrainers } from '../../lib/sanity';

function Trainers() {
  return (
    <TeamSection
      titlePlain="Meet Our"
      titleAccent="Trainers"
      subtitle="H Academy proudly introduces our certified trainers."
      fetchMembers={getAllTrainers}
      loadingLabel="Loading trainers..."
      emptyMessage="Our trainer profiles are coming soon."
    />
  );
}

export default Trainers;
